(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations-cart"]) return;
  try {
    
  document.addEventListener('cart_page:rerender', function() {
    const section = document.querySelector('[data-section-id="product-recommendations-cart"]');

    if (section.getAttribute('data-cart-page')) {
      fetch('/cart?section_id=product-recommendations-cart')
        .then(function(response) {
            return response.text();
        })
        .then(function(text) {
            const newContent = document.createElement('div');
            newContent.innerHTML = text;
            return newContent;
        })
        .then(function(doc) {
            const newSection = doc.querySelector('[data-section-id="product-recommendations-cart"]');
            section.replaceWith(newSection);
            new window.ProductRecommendationsSection(newSection);
        })
        .catch(function(err) {
            console.error(err); 
        });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
